export function copy(list) {
  return JSON.parse(JSON.stringify(list));
}

export function stringify(data) {
  return copy(data).map((item, i) => {
    for (var prop in item) {
      if (typeof item[prop] === 'boolean') item[prop] = String(item[prop]);
      else if (item[prop] === null) item[prop] = '';
    }
    item.ID = i;
    return item;
  });
}

export function sort(definition) {
  return definition
    .filter((item) => item.sort)
    .map((item) => ({ field: item.label, dir: 'asc' }));
}

export function getColumnNames(definition) {
  return definition
    .filter((item) => item.visible)
    .map((item) => ({
      field: item.key,
      label: item.label,
      updatable: item.updatable,
      children:
        item.children !== undefined ? getColumnNames(item.children) : [],
    }))
    .sort((a, b) => {
      let c = definition.find((item) => a.field === item.key);
      let d = definition.find((item) => b.field === item.key);
      return c.order < d.order ? -1 : 1;
    });
}

export function flatten(items) {
  const flat = [];
  items.forEach((item) => {
    if (item.children !== undefined) {
      flat.push(...flatten(item.children));
    } else {
      flat.push(item);
    }
  });

  return flat;
}

export function isBtn(item) {
  return item === "consulter";
}


export function isCheckBox(data, item) {
  return data.length > 0
    ? data.some(
      (lstItem) => lstItem[item] === 'false' || lstItem[item] === 'true'
    ) || data.some(
      (lstItem) => lstItem[item] === false || lstItem[item] === true
    )
    : false;
}

export function getColumnNamesFromArray(label) {
  const obj = {};
  let columnNames = getColumnNames(label).map((x) => x.field);
  for (const key of columnNames) obj[key] = '';
  return obj;
}

export function calculateWidth(item, isLast, data, autoSize, isDate = false) {
  let maxWidth = 0;

  const fieldSize = calculateTextWidth(item.label, {
    font: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    fontSize: '16px',
    fontWeight: 'bold'
  });

  maxWidth = fieldSize;
  const headerSize = calculateTextWidth(item.Label, {
    font: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    fontSize: '16px',
    fontWeight: 'bold'
  });

  maxWidth = Math.max(headerSize, maxWidth);

  data.forEach((value) => {
    const contentSize = calculateTextWidth(value[item.field], {
      font: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
      fontSize: '16px',
      fontWeight: 'bold'
    });

    if (contentSize > maxWidth) {
      maxWidth = contentSize > 500 ? 500 : contentSize;
    }
  });

  if (item.label === "consulter" || item.label === "Consulter") return { width: 105 };

  if ((isLast && data.length !== 0) || !autoSize) return {};

  if (isDate)
    return { width: maxWidth + 75 };

  if (item.label === "Note")
    return { width: maxWidth + 100 };

  return { width: maxWidth + 35 };
}

function calculateTextWidth(text, font) {
  let element = document.createElement('canvas');
  let context = element.getContext("2d");
  context.font = font;

  return context.measureText(text).width + 50;
}
